export const removeSubdomainAndRedirect = () => {
  const host = window.location.host
  const protocol = window.location.protocol
  const url = host.replace(/^[^.]+\./g, '')
  window.location.replace(`${protocol}//${url}`)
}

export const getSubdomain = () => {
  const hostname = window.location.hostname.split('.')
  const hostnameLength = process.env.NODE_ENV === 'production' ? 2 : 1
  if (hostname.length > hostnameLength) {
    return hostname[0] === 'www' || hostname[0] === 'backoffice' || hostname[0] === 'release'
      ? null
      : hostname[0]
  } else {
    return null
  }
}

export const getParamInRouteHash = ($route, paramName) => {
  const params = $route.hash.split('#')[1].split('&')
  const paramValue = params.find(param => param.includes(paramName)).split('=')[1]
  return paramValue
}

export const getGoogleAccessToken = ($route) => {
  const params = $route.hash.split('#')[1].split('&')
  const token = params.find(param => param.includes('access_token')).split('=')[1]
  return token
}

export const getInviteTokenFromHash = (hash) => {
  const params = hash.split('#')[1].split('&')
  const token = params.find(param => param.includes('state')).split('=')[1]
  return token
}
